export const SUPPORT_PHONE_NUMBER = "8334330363";
export const SUPPORT_EMAIL =
  process.env.REACT_APP_SUPPORT_EMAIL || "support@ourlinkedlives.com";
export const BILLING_EMAIL =
  process.env.REACT_APP_BILLING_EMAIL || "billing@ourlinkedlives.com";
export const SCHEDULING_EMAIL =
  process.env.REACT_APP_SCHEDULING_EMAIL || "scheduling@ourlinkedlives.com";
